
export const LottieScroll = () => {

  return (
    <div>Lottie</div>
  )
}

